import "./_doughnut-chart.scss";
import {Chart} from "chart.js/auto";

export default function DoughnutCharts() {
    const doughnutChart = document.querySelectorAll('.doughnut-chart');

    doughnutChart.forEach(chart => {
        const number = chart.querySelector('.number') as HTMLElement;
        const titleChart = chart.querySelector('.title-container') as HTMLElement;
        const titleWrapper = chart.querySelector('.title-wrapper') as HTMLElement;
        const title = titleWrapper.querySelector('.title') as HTMLElement;
        const description = titleWrapper.querySelector('.subtitle') as HTMLElement;
        const dataChart = chart.querySelector('.data-chart') as HTMLScriptElement;
        let data: any;

        if(number) {
            titleChart.classList.add('has-number');
        }

        if(title.innerHTML === '' && description.innerHTML === '') {
            titleWrapper.classList.add('d-none');
        }

        if (dataChart) {
            try {
                data = JSON.parse(dataChart.innerHTML);
            } catch (e) {
                data = [];
            }
        }

        let ctx = chart.querySelector('.chart-content') as any;
        if (ctx && data && data.length > 0) {
            new Chart(ctx, {
                type: 'doughnut',
                data: {
                    datasets: [
                        {
                            data: data.map((item: any) => Math.max(item.value, 0.001)),
                            backgroundColor: data.map((item: any) => (item.value > 0 ? item.color : 'rgba(0, 51, 102, 0.20'))
                        }
                    ],
                },
                options: {
                    cutout: 135,
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        tooltip: {
                            enabled: false
                        },
                        legend: {
                            display: false,
                        }
                    }
                },
            });
        }
    })
}